module.exports = {"640105001":"西花园路街道","640105002":"北京西路街道","640105003":"文昌路街道","640105004":"朔方路街道","640105005":"宁华路街道","640105006":"贺兰山西路街道","640105007":"怀远路街道","640105100":"兴泾镇","640105101":"镇北堡镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/640105.json
// module id = 3168
// module chunks = 0